import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Rmx_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModalRmx = () => {
  return (
    <>
      <ModalVideo
        id="spot-rmx"
        dataText={Rmx_Title}
        videoSrc="https://player.vimeo.com/video/201943989?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_RMX"
      />
    </>
  );
};

export default ModalRmx;
